export const PromotionBasicFields = `
  fragment PromotionBasicFields on Promotion {
    id
    name
    type
    description
    storeType
    promotionPeriodId
    promotionStoreId
    files {
      identityId
      userId
      filename
      uploader
    }
  }
  `;
